__turbopack_context__.v({
  "AuthWidget": "qt-0rG_AuthWidget",
  "Ok": "qt-0rG_Ok",
});
